export default __webpack_public_path__ + "static/aaa-lg-bf743bf59856ede23eb94958c414f731.svg";